import { DateTime } from 'luxon';

import { DayNum } from '../../../types';
import { StoreHours, StoreOpenStatus } from '../../types';
import { getStoreDiffFromMoment } from '../getStoreDiffFromMoment';
import { getStoreOpenStatusFromDiff } from '../getStoreOpenStatusFromDiff';

export const getOpenStatusAtMoment = (
	storeHours: StoreHours,
	time: DateTime
): StoreOpenStatus => {
	const day = time.weekday;
	const specifiedDayHours = storeHours[day as DayNum];
	if (!specifiedDayHours) {
		const nextDay = time.plus({ days: 1 }).weekday;
		const nextDayHours = storeHours[nextDay as DayNum];
		if (!nextDayHours) {
			return 'NEVER';
		}
		return 'OPEN_TOMORROW';
	}
	const diff = getStoreDiffFromMoment(specifiedDayHours, time);
	return getStoreOpenStatusFromDiff(diff);
};
